import axios from "axios";

if (!import.meta.env.VITE_API_BASE_URL) {
  throw new Error("Arquivo .env não encontrado");
}

export default axios.create({ baseURL: import.meta.env.VITE_API_BASE_URL });
